import { createI18n } from 'vue-i18n'
import { defaultLang, getLocale } from 'src/common/functions'
import messages from 'src/i18n/index.js'

let i18nObject = null

export default async (ctx) => {
  const { app, store } = ctx

  const locale = store.getters.getUserLanguage || getLocale()

  i18nObject = createI18n({
    legacy: false,
    locale,
    globalInjection: true,
    fallbackLocale: defaultLang,
    messages,
  })

  app.use(i18nObject)
}

export { i18nObject }
